import { useState, useEffect } from "react";
import axios from "axios";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import ServicesSection from "@/components/ServicesSection";
import AboutSection from "@/components/AboutSection";
import GallerySection from "@/components/GallerySection";
import TestimonialsSection from "@/components/TestimonialsSection";
import QuoteSection from "@/components/QuoteSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const HomePage = () => {
  const [services, setServices] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [gallery, setGallery] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [servicesRes, testimonialsRes, galleryRes] = await Promise.all([
          axios.get(`${API}/services`),
          axios.get(`${API}/testimonials`),
          axios.get(`${API}/gallery`)
        ]);
        setServices(servicesRes.data);
        setTestimonials(testimonialsRes.data);
        setGallery(galleryRes.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  return (
    <div className="min-h-screen bg-[#f8f9fa]" data-testid="home-page">
      <Header />
      <main>
        <HeroSection />
        <ServicesSection services={services} />
        <AboutSection />
        <GallerySection gallery={gallery} />
        <TestimonialsSection testimonials={testimonials} />
        <QuoteSection services={services} />
        <ContactSection />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default HomePage;
